exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.basic-img[data-v-76fc944f]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/components/basic/goodsmanage/basic-img.vue"],"names":[],"mappings":";AAaA,4BACE,oBAAA,oBAAA,YAAa;CACd","file":"basic-img.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n.basic-img {\n  display: flex;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76fc944f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/basic/goodsmanage/basic-img.vue
// module id = mVpZ
// module chunks = 2